<template>
  <div>
    <v-row :class="customClass?customClass:'px-10 pt-3 pb-5'">
      <v-col v-for="(item) in arrayData" :key="item.id" :lg=colNum sm="3" md="3" >
        <v-template :class="item.labelCss" class="ma-0 pa-0 secondary--text">{{item.label}}</v-template> <br />
          <v-chip v-if="rlpStatusChips && item.label === 'RLP Status' && item.value" small
            :color="/out\s+of\s+sync/i.test(item.value) ? 'warning' : 'success'" text-color="white"
            class="display-value-chip">{{ item.value }}</v-chip>
          <v-chip v-else-if="hasValueMismatch && mismatchLabels.includes(item.label)" small color="error" text-color="white"
            class="display-value-chip">{{ item.value }}</v-chip>
          <div v-else :class="item.valueCss" class="ma-0 pa-0 f-bold f-12"  v-html="formatedValues(item.value)"></div>
          <div class="ma-0 pa-0 f-10" v-html="formatedValues(item.subValue || '')"></div>
    </v-col>
  </v-row>
  </div>
</template>
<script>
import Utility from "../../shared/utility";
export default {
  name: 'exportLimit',
  props: {
    arrayData: Array,
    colNum:Number,
    customClass:String,
    rlpStatusChips: Boolean,
    mismatchLabels: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {

    }
  },
  mounted(){
  },
  computed: {
    hasValueMismatch() {
      const values = this.mismatchLabels.map(label =>
        String(this.arrayData?.find(item => item.label === label)?.value ?? "")
          .trim().toUpperCase().replace(/^RE-DEPLOY$/, "REDEPLOY"));
      return values.length > 1 && values.every(Boolean) && values.some(value => value !== values[0]);
    },
  },
  methods: {
    formatedValues(value){
    return Utility.insertLineBreaks(value,1,"|")}
  },
  
}
</script>
<style scoped>
.display-value-chip {
  max-width: 100%;
  height: auto !important;
  min-height: 24px;
}

.display-value-chip ::v-deep(.v-chip__content) {
  white-space: normal;
  overflow-wrap: anywhere;
  padding: 3px 0;
}
</style>
